import {
  LoginProxy,
  GetUsersMeProxy,
  QueryStringHelper,
} from "@sleek/customer-common-acquisition";

import get from "lodash/get";

const getDefaultState = () => {
  return {
    user: null,
    userFormData: null,
    companyUser: null,
    role: null,
    userMe: null,
    corporateShareholderData: null,
    PEPDeclarationData: null,
    completeShareholderSection: null,
    userHasAcceptedOtherCompany: null,
    RCDReviewAndCompletedData: null,
    isVerifyBySingpass: false,
    dataSource: "",
  };
};

const state = getDefaultState();

const getters = {
  getUser: (state) => state.user,
  userMe: (state) => state.userMe,
  isVerifyBySingpass: (state) => state.isVerifyBySingpass,
  isKycRefreshTriggered: (state) => {
    return get(state.companyUser, "kyc_status") === "refresh_triggered";
  },
  getDataSource: (state) => state.dataSource,
};

const actions = {
  async processOtpVerification({ state }) {
    const proxy = new LoginProxy();
    return proxy.execute(state.userFormData);
  },
  // eslint-disable-next-line no-empty-pattern
  async getLoginAuth({}, payload) {
    const proxy = new LoginProxy();
    const response = await proxy.execute(payload);
    return response;
  },
  async getUsersMe({ commit }) {
    const proxy = new GetUsersMeProxy();
    const data = await proxy.execute();
    commit("setUserMe", data);
    return data;
  },
  logout({ commit }) {
    commit("logout");
  },
  async getIsVerifyBySingpass({ state, commit }) {
    const queryStringHelper = new QueryStringHelper();
    const isFromKycRefresh = queryStringHelper.get("isFromKycRefresh");
    commit(
      "setIsVerifyBySingpass",
      get(state.companyUser.user, "retrieved_info") &&
        get(state.companyUser.user, "retrieved_info.status") === "accepted" &&
        get(state.companyUser, "kyc_status") === "refresh_triggered" &&
        isFromKycRefresh === "true"
    );
  },
};

const mutations = {
  setUser(state, payload) {
    state.user = payload;
    localStorage.setItem("user", JSON.stringify(state.user));
  },
  setUserFormData(state, payload) {
    state.userFormData = payload;
    localStorage.setItem("userFormData", JSON.stringify(state.userFormData));
  },
  setCompanyUser(state, payload) {
    state.companyUser = payload;
  },
  setRole(state, payload) {
    state.role = payload;
  },
  setUserMe(state, payload) {
    state.userMe = payload;
  },
  setCorporateShareholderData(state, payload) {
    state.corporateShareholderData = payload;
  },
  setPEPDeclarationData(state, payload) {
    state.PEPDeclarationData = payload;
  },
  setRCDReviewCompletedData(state, payload) {
    state.RCDReviewAndCompletedData = payload;
  },
  setCompleteShareholderSection(state, payload) {
    state.completeShareholderSection = payload;
  },
  setUserHasAcceptedOtherCompany(state, payload) {
    state.userHasAcceptedOtherCompany = payload;
  },
  logout(state) {
    Object.assign(state, getDefaultState());
  },
  setIsVerifyBySingpass(state, payload) {
    state.isVerifyBySingpass = payload;
  },
  setDataSource(state, payload) {
    state.dataSource = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
